<!-- 
	WinWinFooter
	props: N/A
  role: Public
	Called by @/App for a fancy footer with external links
  Disabled on mobile screens due to headache
-->

<template>
	<header
		class="header hidden md:block blue-bg text-white py-4 text-center"
	>
		<div class="flex items-center lg:w-2/3 xl:w-2/3 mx-auto">
			<!--
			<div class="flex-1 text-left">
				<span class="text-center inline-block header-line" style="cursor:pointer" @click="handleGoToQuestions">
					<div class="fancy-font winwin-gold capitalize bigger-font">Got</div>
					<div>Questions?</div>
				</span>
				<span class="header-line">
					<a href="https://winwinstafflottery.ca" target="_blank">Home</a>
				</span>
				<span class="header-line"><a href="https://winwinstafflottery.ca/proceeeds" target="_blank">Proceeds</a></span>
			</div>
			-->
			<div class="center-logo">
			<a href="/">
				<img src="../assets/logo-winwin.svg" alt="logo" class="logo center-logo" />
			</a>
			</div>
			<!--
			<div class="flex-1 text-right">
				<span class="header-line"><a href="https://winwinstafflottery.ca/winners" target="_blank">Winners</a></span>
				<span class="header-line"><a href="https://winwinstafflottery.ca/contact" target="_blank">Contact</a></span>
				<span class="text-center inline-block header-line" style="cursor:pointer" @click="handleGoToTickets">
					<div class="fancy-font winwin-gold capitalize bigger-font">Get</div>
					<div>Tickets</div>
				</span>
			</div>
			-->
		</div>
	</header>
</template>

<script>
	import firebase from "firebase";
	import { mapGetters } from "vuex";

	export default {
		name: "WinWinHeader",
		computed: {
			...mapGetters({
				user: "user",
			}),
		},
		methods: {
			handleGoToQuestions() {
				window.open("https://winwinstafflottery.ca/faqs", "_blank")
			},
			handleGoToTickets() {
				window.open("https://winwinstafflottery.ca/tickets", "_blank")
			}
		}
	};
</script>

<style scoped>
	.header .logo {
		max-width: 150px;
		width: 100%;
	}

	.header .link {
		padding-left: 22px;
		cursor: pointer;
	}

	.blue-bg {
		background-color: #1a1f56;
	}

	.header-line {
		text-transform: uppercase;
		font-weight: 700;
		padding: 0 30px;
	}

	.header .bigger-font {
		margin-top: -15px;
		font-size: 30px;
		line-height: 1;
	}

	.center-logo {
	display: block;
	margin-left: auto;
	margin-right: auto;
	width: 50%;
	}

</style>
